import { render } from "./ChangeThemeModal.vue?vue&type=template&id=f1229554"
import script from "./ChangeThemeModal.vue?vue&type=script&lang=js"
export * from "./ChangeThemeModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__